import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const NotAvailableBar = styled.span`
    width: 16px;
    height: 3px;
    background-color: ${Colors.Gray.V300};
    border-radius: 8px;
`;
